/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { useNavigate } from "react-router-dom";
import PaymentForm from "./PaymentForm";
import { usePaymentContext } from "../context/PaymentContext";
import { useDarkMode } from "../context/DarkModeContext";

const PaymentFormWrapper: React.FC = () => {
  const navigate = useNavigate();
  const { state } = usePaymentContext();
  const { isDark } = useDarkMode();

  const handleSuccess = (paymentIntent: any) => {
    console.log("Payment successful:", paymentIntent);
    navigate("/dashboard", {
      state: { message: "Payment completed successfully!" },
    });
  };

  const handleCancel = () => {
    navigate("/dashboard/subscriptions");
  };

  // Show loading or error if no plan is selected
  if (!state.selectedPlan) {
    return (
      <div
        className={`max-w-md mx-auto p-6 rounded-2xl shadow-lg ${
          isDark
            ? "bg-gray-800 border border-gray-700"
            : "bg-white border border-gray-200"
        }`}
      >
        <div className="text-center">
          <h3
            className={`text-xl font-bold mb-4 ${
              isDark ? "text-white" : "text-gray-800"
            }`}
          >
            No Plan Selected
          </h3>
          <p className={`mb-6 ${isDark ? "text-gray-300" : "text-gray-600"}`}>
            Please select a plan before proceeding to payment.
          </p>
          <button
            onClick={() => navigate("/dashboard/subscriptions")}
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-colors font-medium"
          >
            Choose a Plan
          </button>
        </div>
      </div>
    );
  }

  return <PaymentForm onSuccess={handleSuccess} onCancel={handleCancel} />;
};

export default PaymentFormWrapper;
